import "@fontsource-variable/bricolage-grotesque";
import "@fontsource-variable/manrope";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import LoginPage from "./LoginPage";
import { StudioProvider } from "./StudioContext";
import "./styles.css";

function Root() {
  if (window.location.pathname === "/login") return <LoginPage />;

  return (
    <StudioProvider>
      <App />
    </StudioProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>
);
